import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { VENDOR_ANALYTICS_PERIODS } from '../../utils/analytics';
import SegmentedControl from './SegmentedControl';

function StatsPeriodToggle({ value, onChange, className = '' }) {
  const { t } = useLanguage();
  const labels = t.statsCard?.periods || {};

  const options = VENDOR_ANALYTICS_PERIODS.map((period) => ({
    value: period,
    label: labels[period] || period,
  }));

  return (
    <SegmentedControl
      value={value}
      onChange={onChange}
      options={options}
      className={className}
      layoutId="stats-period-segment"
      aria-label={t.statsCard?.periodToggleLabel || 'Stats period'}
    />
  );
}

export default StatsPeriodToggle;
